import { Component, Input, OnInit } from '@angular/core';
import { Priority } from '../../../models/price-monitoring-task/Priority';
import { TaskPriorityEnumValues } from '../../../models/product-evaluation-tasks/enums/TaskPriorityEnumValues';

@Component({
  selector: 'app-price-monitoring-task-priority',
  standalone: false,
  templateUrl: './price-monitoring-task-priority.component.html'
})
export class PriceMonitoringTaskPriorityComponent implements OnInit {

  @Input({ required: true }) priority: Priority;
  priorityEnum = TaskPriorityEnumValues;

  constructor() { }

  ngOnInit() {
  }

}
